import dynamic from "next/dynamic";
const Campaign = dynamic(() => import("@/components/campaign/Campaign"));
import { useI18n } from "@/i18n/I18nProvider";
const PageHead = dynamic(() => import("@/components/PageHead"));

export default function FinancingPage() {
  const { t } = useI18n();

  return (
    <>
      <PageHead
        title={t?.pages_main_tags?.financing.title}
        description={t?.pages_main_tags?.financing.meta_desc}
      />
      <Campaign
        type="financing"
        title={t.Campaign.financing_title}
        subTitle={t.Campaign.financing_pg}
        source={24}
      />
    </>
  );
}
